<template>
  <list-layout :tableTools="false">
    <template slot="header" >
      <div class="px-4 lg:px-10 font-medium dark:text-white mb-2 flex gap-4 items-center">
        <h2>{{ $t('products.header') }}</h2>
        <el-form-item prop="products" class="flex-1">
        </el-form-item>
      </div>
    </template>
    <template slot="table-core">
      <base-table-pagination 
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row space-x-2">
        <base-button-responsive size="xs" class="w-full md:w-auto" icon="plus" :text="$t('invoices.invoices_issuing.step4.create_product')" @click="goPorductCreation" :loading="isGeneralLoading" />
        <div class="flex flex-row w-100 gap-4">
          <base-table-search @toggleFilters="toggleFilters" />
        </div>
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags hide-save :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
      <kendo-grid-component 
        :value="value"
        value-key="idProducto"
        value-type="data-item"
        :spanish="spanish"
        :data="data"
        :kendo="kendo"
        :loading="isGeneralLoading"
        :selectedField="selectedField"
        :inEditField="inEditField"
        :inEditDetailField="inEditDetailField"
        :expandField="selectedField"
        :update-columns="false"
        edit-on-row-click
        @input="$emit('input', $event)"
        @datastatechange="dataStateChange">
          <template v-slot:kendorowdetail="{ props, listeners }">
            <step-4-product-detail-row v-bind="props" autosave v-on="listeners" />
          </template>
      </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
      <create-search-dialog :numberSearches="numberSearches" :idVista="idVista" :dialogOpen="saveSearchDialog"
        :tags="tags" @toggleDialog="toggleDialogSearches" @applyDialog="applySearchHandler" />
    </template>
  </list-layout>
</template>
<script>
import { i18n } from '@/i18n'

import getNestedValue from '@/services/functions/getNestedValue'
// import hasNestedValue from '@/services/functions/hasNestedValue'
import setNestedValue from '@/services/functions/setNestedValue'
import { getProductsWithTaxesPag } from '@/services/configurations/getProductsWithTaxesPag'

import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/Step4ProductsFilter.vue'
import KendoGridComponent from '@/components/KendoGridComponentV2.vue'
import Step4ProductDetailRow from '@/components/Step4ProductDetailRow.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import { cloneDeep } from 'lodash'
import hasNestedValue from '@/services/functions/hasNestedValue'


export default {
  name: 'step4-product-table',
  components: {
    // Loading,
    ListLayout,
    FilterPanel,
    KendoGridComponent,
    Step4ProductDetailRow,
    CreateSearchDialog,
  },
  props: {
    value: Array,
    ruleForm: Object,
    idCliente: [Number, String]
  },
  data () {
    return {
      // Searches
      idVista: 66,
      numberSearches: 0,
      saveSearchDialog: false,
      // All
      spanish: true,
      vuexnamespace: 'invoicesIssuing/4/products',
      selectedField: 'selected',
      inEditField: 'inEdit',
      inEditDetailField: 'inEditDetail',
      filterPanel: false,
      loadingDataTable: false,
      additionalLineItemInformationMaxLength: '2500',
      data: [],
      selected: [],
      zeroTax: []
    }
  },
  computed: {
    hasOperationType: function () {
      return this.operationType === 1 || this.operationType === 2 || this.operationType === 3
    },
    operationType: function () {
      return this.$store.getters['invoicesIssuing/2/form']?.tipoImpuestoFactura
    },
    hasEquivalenceSurcharge: function () {
      return this.$store.getters['invoicesIssuing/2/form']?.applyEquivalenceSurcharge
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading || this.loadingCompanies || this.loadingCompanyData || this.loadingContacts
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    tiposOperacion: function () {
      return this.$store.getters['config/TIPOS_OPERACION_TRIBUTACION'].filter(x => x.id === this.operationType)[0].name
    },
  },
  async mounted () {
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
    this.data = await this.applyFilters()
    if (this.hasOperationType) {
      this.zeroTax.push({
        Name: this.tiposOperacion || this.operationType,
        TaxType: '01',
        TaxRate: 0,
        TaxCategory: 0,
        idImpuesto: -1
      })
    }
  },
  methods: {
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    dataStateChange: async function (event) {
      this.data = await this.applyFilters()
    },
    getParamsFilter (data) {
      const params = {
        ItemDescription: data.ItemDescription ? data.ItemDescription.value : null,
        UnitOfMeasure: data.UnitOfMeasure ? data.UnitOfMeasure.value : null,
        UnitPriceWithoutTaxMin: data.UnitPriceWithoutTaxMin ? data.UnitPriceWithoutTaxMin.value : null,
        UnitPriceWithoutTaxMax: data.UnitPriceWithoutTaxMax ? data.UnitPriceWithoutTaxMax.value : null,
        ArticleCode: data.ArticleCode ? data.ArticleCode.value : null,
      }
      if (this.role !== '' && [3, 7, 8].includes(this.role)) {
        params.idCliente = this.idCliente || null
      }
      return params
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      this.$store.commit('setIsLoading', true)
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = this.getParamsFilter(data)
      const obj = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        const data = await this.getItemsData(obj, params)
        return data
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }
      return null
    },
    getItemsData: async function (orders, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(orders, params)
      const data = res.Respuesta
      data.forEach(this.initialiceProduct)

      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false

      if (pagination.currentPage > pagination.totalPages) {
        this.applyFiltersHandler()
      }

      return data
    },
    async getMainData (orders, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getProductsWithTaxesPag(orders, params)

      if (data.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
      }
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters()
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      try {
        this.data = await this.applyFilters()
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }
    },
    removeFilterTagHanlder: async function (tag) {
      this.unselect()
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.data = await this.applyFilters()
    },
    headerCoreFiltersHandler: async function (obs) {
      if (this.isHeadCoreReady) {
        this.data = await this.applyFilters()
      }
    },
    removeAllTagsHandler: async function () {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.data = await this.applyFilters()
    },
    unselect: function () {
      this.$emit('input', [])
    },
    initialiceProduct: function (dataItem) {
      const selectedDataItem = null;
      // const selectedDataItem = this.value.find(x => x.idProducto === dataItem.idProducto);
      ['subtotal', 'descuentos[0].descuento', 'descuentos[0].cuota', 'cuotaRecargo', 'total', 'totalConImpuesto', 'additionalLineItemInformation'].forEach(key => {
        const currentValue = getNestedValue(key, dataItem)
        if (currentValue === undefined || currentValue === null) {
          setNestedValue(key, dataItem, selectedDataItem?.[key] || '', true)
        }
      })
      if (!dataItem.Taxes?.[0]) {
        setNestedValue('Taxes[0]', dataItem, selectedDataItem?.Taxes?.[0] || cloneDeep(dataItem.Impuestos[0]) || '', true)
      }
      if (dataItem.descuentos[0].incluyeDescuento === undefined || dataItem.descuentos[0].incluyeDescuento === null) {
        const incluyeDescuento = selectedDataItem?.descuentos?.[0]?.incluyeDescuento
        setNestedValue('incluyeDescuento', dataItem.descuentos[0], typeof incluyeDescuento === 'boolean' ? incluyeDescuento : '', true)
      }
      if (dataItem.cantidad === undefined || dataItem.cantidad === null) {
        setNestedValue('cantidad', dataItem, selectedDataItem?.cantidad || '1', true)
      }
      if (!hasNestedValue(this.inEditDetailField, dataItem)) {
        setNestedValue(this.inEditDetailField, dataItem, getNestedValue(this.inEditDetailField, selectedDataItem) ?? true)
      }
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
    validate: function () {
      if (this.ruleForm) {
        this.ruleForm.validateField('products')
      }
    },
    goPorductCreation: function () {
      this.$store.dispatch('app/enterMode', 1)
      this.$router.push({ 
        name: 'masters/products/details',
        params: { id: -1, idCliente: this.idCliente }
      })
    } 
  }
}
</script>
<style>
.k-animation-container.k-animation-container-relative.k-animation-container-shown {
  z-index: 9999;
}
</style>
<style scoped>
::v-deep .el-input__count .dark {
  @apply text-darkblue-100 mt-1;
  background-color: transparent;
}
::v-deep .el-input__count {
  @apply mt-1;
  background-color: transparent;
}

@media (min-width: 1024px) {
  ::v-deep .lg\:max-w-detail {
    max-width: unset;
  }
}
</style>
